module.exports = __webpack_public_path__ + "static/fonts/rajdhani-regular-webfont.f04cbe5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-regular-webfont.woff2
// module id = 102
// module chunks = 0